/* global feag */

import bus from '../util/eventBus';

const loadmore = () => {
  const btn = document.querySelector('[data-load-more]');
  if (btn) {
    btn.addEventListener(
      'click',
      e => {
        const targetElement = e.target || e.srcElement;

        const originalBtnText = targetElement.innerText;
        targetElement.innerText = feag.namespace.loading;
        targetElement.classList.add('disabled');

        const formData = new FormData();
        formData.append('action', 'loadmore');
        formData.append('page', feag.current_page);

        const request = new XMLHttpRequest();

        request.open('POST', feag.ajaxurl, true);
        // eslint-disable-next-line func-names
        request.onload = function() {
          if (this.status >= 200 && this.status < 400) {
            targetElement.innerText = originalBtnText;

            const resultWrapper = document.querySelector(
              '.c-socialmedia > .u-masonry',
            );
            resultWrapper.innerHTML += this.responseText;

            // eslint-disable-next-line no-plusplus
            feag.current_page++;
            if (feag.current_page >= feag.max_page) {
              targetElement.classList.add('disabled');
              targetElement.innerText = feag.namespace.no_posts;
              resultWrapper.parentElement.classList.add(
                'c-socialmedia--loaded',
              );
            } else {
              targetElement.classList.remove('disabled');
            }

            bus.emit('feag-load-more-finish', true);
          }
        };
        request.send(formData);
      },
      false,
    );
  }
};

loadmore();
